import { createRouter, createWebHashHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";

import LoginView from "@/views/LoginView.vue";
import DesktopLayout from "@/layouts/DesktopLayout.vue";
import HomeView from "@/views/HomeView.vue";
import RealEstateSellingView from "@/views/RealEstateSellingView.vue";
import RealEstateTrendView from "@/views/RealEstateTrendView.vue";
import RealEstateTopSellingView from "@/views/RealEstateTopSellingView.vue";

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    // ✅ 메인 진입은 로그인
    { path: "/", name: "login", component: LoginView },

    // ✅ 로그인 후 보이는 "윈도우 스타일" 레이아웃
    {
      path: "/app",
      component: DesktopLayout,
      meta: { requiresAuth: true },
      children: [
        { path: "", name: "home", component: HomeView },
        { path: "selling", name: "selling", component: RealEstateSellingView },
        { path: "top", name: "top", component: RealEstateTopSellingView },
        { path: "trend", name: "trend", component: RealEstateTrendView },
      ],
    },

    // 404 처리(optional)
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});

// ✅ 인증 가드
router.beforeEach((to) => {
  const auth = useAuthStore();
  if (to.meta.requiresAuth && !auth.isAuthed) {
    return { name: "login" };
  }
  // 이미 로그인 상태에서 로그인 페이지 접근 시 /app 이동
  if (to.name === "login" && auth.isAuthed) {
    return { name: "home" };
  }
});

export default router;
